import LayoutExterno from '~componentes/LayoutExterno.vue';
import LiberarCancelarSolicitacao from './componentes/LiberarCancelarSolicitacao.vue';

export default {
  path: '/cancelar-solicitacao/:id/:coordenador',
  component: LayoutExterno,
  children: [
    {
      name: 'cancelar-solicitacao.compra',
      path: 'compra',
      component: LiberarCancelarSolicitacao
    },
    {
      name: 'cancelar-solicitacao.pagamento',
      path: 'pagamento',
      component: LiberarCancelarSolicitacao
    },
    {
      name: 'cancelar-solicitacao.reembolso',
      path: 'reembolso',
      component: LiberarCancelarSolicitacao
    },
    {
      name: 'cancelar-solicitacao.faturamento',
      path: 'faturamento',
      component: LiberarCancelarSolicitacao
    },
    {
      name: 'cancelar-solicitacao.faturamento-multiservico',
      path: 'faturamento-multiservico',
      component: LiberarCancelarSolicitacao
    },
    {
      name: 'cancelar-solicitacao.bolsa',
      path: 'bolsa',
      component: LiberarCancelarSolicitacao
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-cancelar-solicitacao/rotas-cancelar.js